import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, Switch } from "react-router-dom";
import RxPrivateRoute from "./components/RxPrivateRoute";
import api from "./config/AxiosConfig";
import { SuccessResponseDTO, UserInfoDTO } from "./constants/CommonObject";
import Layout from "./hoc/Layout";
import AcademicLicencePage from "./pages/acamedic-licence";
import ActivateUserPage from "./pages/activate-user";
import CartPage from "./pages/cart";
import ForgetPasswordPage from "./pages/forget-password";
import InfoPage from "./pages/info";
import LoginPage from "./pages/login";
import MainPage from "./pages/main";
import OrderHistoryPage from "./pages/order-history/OrderHistoryPage";
import Payment from "./pages/payment";
import PaymentResultPage from "./pages/payment/PaymentResult";
import RedirectPage from "./pages/redirect";
import RegisterPage from "./pages/register/RegisterPage";
import ResetPasswordPage from "./pages/reset-password";
import SalePage from "./pages/sale";
import { RxShoppingCartObject } from "./pages/sale/SalePage";
import UpdateUserPage from "./pages/update-user";
import { setCart } from "./redux/slices/cart-slice";
import { setRecaptcha } from "./redux/slices/recaptcha-slice";
import { setUserInfo } from "./redux/slices/user-slice";
import { store } from "./redux/store";

const App = () => {
	const isUserLoggedIn = useSelector((state: any) => state.user.userLoggedIn);
	const userEmail = useSelector((state: any) => state.user.userInfo.email);

	const getReCaptcha = async () => {
		const response: SuccessResponseDTO = await api.get("/recaptcha");
		store.dispatch(
			setRecaptcha({
				siteKey: response.responseValue,
			})
		);
	};

	const getUserInfo = async () => {
		const response: UserInfoDTO = await api.get("/1/users/info");
		store.dispatch(
			setUserInfo({ email: response?.email, name: response?.name })
		);
	};

	const getBasketInfoForCartItems = async () => {
		await api.get("/1/basket").then((response: RxShoppingCartObject) => {
			store.dispatch(
				setCart({
					cartItem: response,
				})
			);
		});
	};

	useEffect(() => {
		if (isUserLoggedIn && userEmail === "") {
			getUserInfo();
			getBasketInfoForCartItems();
		}
	}, [isUserLoggedIn, userEmail]); // eslint-disable-line

	useEffect(() => {
		getReCaptcha();
	}, []); // eslint-disable-line

	let routes = (
		<Switch>
			<Route exact path="/security-policy/:infoDocVersion?">
				<InfoPage infoUrl="/1/documents/security-policy" />
			</Route>
			<Route exact path="/kvkk/:infoDocVersion?">
				<InfoPage infoUrl="/1/documents/kvkk" />
			</Route>
			<Route exact path="/sale-contract/:infoDocVersion?">
				<InfoPage infoUrl="/1/documents/sale-contract" />
			</Route>
			<Route exact path="/membership/:infoDocVersion?">
				<InfoPage infoUrl="/1/documents/membership" />
			</Route>
			<Route path="/login:redirectPath?">
				<LoginPage />
			</Route>
			<Route exact path="/register">
				<RegisterPage />
			</Route>
			<Route path="/forget-password">
				<ForgetPasswordPage />
			</Route>
			<Route path="/reset-password/email/:email/code/:code">
				<ResetPasswordPage />
			</Route>
			<Route path="/activation/email/:email/code/:code">
				<ActivateUserPage />
			</Route>
			<RxPrivateRoute exact path="/">
				<MainPage />
			</RxPrivateRoute>
			<RxPrivateRoute exact path="/sale/:categoryId">
				<SalePage />
			</RxPrivateRoute>
			<RxPrivateRoute exact path="/cart">
				<CartPage />
			</RxPrivateRoute>
			<RxPrivateRoute exact path="/payment">
				<Payment />
			</RxPrivateRoute>
			<RxPrivateRoute exact path="/payment/result">
				<PaymentResultPage />
			</RxPrivateRoute>
			<RxPrivateRoute exact path="/edit-user">
				<UpdateUserPage />
			</RxPrivateRoute>
			<RxPrivateRoute exact path="/order-history">
				<OrderHistoryPage />
			</RxPrivateRoute>
			<RxPrivateRoute exact path="/academic-licence">
				<AcademicLicencePage />
			</RxPrivateRoute>
			<RxPrivateRoute path="*">
				<RedirectPage redirectUrl="/" />
			</RxPrivateRoute>
		</Switch>
	);

	return <Layout>{routes}</Layout>;
};

export default App;
